import React, { useState, useRef } from 'react'
import { Button, type ButtonProps } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'

interface ButtonConfirmActionProps {
  confirmText: React.ReactNode
  successBtnText: React.ReactNode
  cancelBtnText?: React.ReactNode
  openBtnText?: React.ReactNode
  isDisabled?: boolean
  onSuccess: () => void
  onCancel?: () => void
  /**
   * Props passed to the trigger <Button> (e.g. variant, size, className, etc.)
   */
  triggerButtonProps?: ButtonProps
}

export default function ButtonConfirmAction({
  confirmText,
  successBtnText,
  cancelBtnText = 'Cancelar',
  openBtnText,
  triggerButtonProps,
  isDisabled,
  onSuccess,
  onCancel
}: ButtonConfirmActionProps) {
  const [popoverOpen, setPopoverOpen] = useState(false)
  const triggerRef = useRef<HTMLButtonElement>(null)
  const contentRef = useRef<HTMLDivElement>(null)

  return (
    <Popover open={popoverOpen} onOpenChange={setPopoverOpen}>
      <PopoverTrigger asChild>
        <Button {...triggerButtonProps} disabled={isDisabled} ref={triggerRef}>
          {openBtnText}
        </Button>
      </PopoverTrigger>

      <PopoverContent ref={contentRef}>
        <div>{confirmText}</div>
        <div className="flex justify-end mt-2">
          <Button
            variant="destructive"
            size="sm"
            onClick={() => {
              onSuccess()
              setPopoverOpen(false)
            }}
          >
            {successBtnText}
          </Button>
          <Button
            variant="outline"
            size="sm"
            className="ml-2"
            onClick={() => {
              setPopoverOpen(false)
              onCancel?.()
            }}
          >
            {cancelBtnText}
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  )
}
